import { render, staticRenderFns } from "./detail_bar.vue?vue&type=template&id=0a935c05&scoped=true"
import script from "./detail_bar.vue?vue&type=script&lang=js"
export * from "./detail_bar.vue?vue&type=script&lang=js"
import style0 from "./detail_bar.vue?vue&type=style&index=0&id=0a935c05&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a935c05",
  null
  
)

export default component.exports